module.exports = __webpack_public_path__ + "static/media/ENTRANCE-FINAL-Model-2.c88d68ca.webp";